import PropTypes from 'prop-types';
import { createContext, useContext, useState, useCallback } from 'react';

export const SearchContext = createContext({});

const SearchProvider = ({ children }) => {
	const [searchResults, setSearchResults] = useState(null);
	const [searchKeyword, setSearchKeyword] = useState('');
	const [showSearchResults, setShowSearchResults] = useState(false);
	const [showSearchCard, setShowSearchCard] = useState(false);
	const [isSearching, setIsSearching] = useState(false);

	const setSearchResultsState = useCallback((results, keyword) => {
		setSearchResults(results);
		setSearchKeyword(keyword);
		setShowSearchResults(true);
		setIsSearching(false);
	}, []);

	const clearSearchResults = useCallback(() => {
		setSearchResults(null);
		setSearchKeyword('');
		setShowSearchResults(false);
		setShowSearchCard(false);
		setIsSearching(false);
	}, []);

	const setShowSearchCardState = useCallback((show) => {
		setShowSearchCard(show);
	}, []);

	const setSearchingState = useCallback((searching) => {
		setIsSearching(searching);
	}, []);

	return (
		<SearchContext.Provider
			value={{
				searchResults,
				searchKeyword,
				showSearchResults,
				showSearchCard,
				isSearching,
				setSearchResultsState,
				clearSearchResults,
				setShowSearchCardState,
				setSearchingState,
			}}
		>
			{children}
		</SearchContext.Provider>
	);
};

SearchProvider.propTypes = {
	children: PropTypes.node.isRequired,
};

export const useSearchContext = () => {
	const context = useContext(SearchContext);
	if (!context) {
		throw new Error('useSearchContext must be used within SearchProvider');
	}
	return context;
};

export default SearchProvider;
